import { render, staticRenderFns } from "./BadgeStyles.vue?vue&type=template&id=2e79f4b6&"
import script from "./BadgeStyles.vue?vue&type=script&lang=ts&"
export * from "./BadgeStyles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports